import { message } from "antd";
import { tableService } from "../services/tables";

const namespace = "tables";
const initialState = {
  list: [],
  loading: {
    fetchList: false,
    fetchMore: false,
    create: false,
    addItemsToTable: false,
  },
  total: 0,
  draftOrders: [],
  currentOrder: null,
};

export const create = (data) => ({
  type: `${namespace}/create`,
  payload: data,
});

export const fetchList = (params) => ({
  type: `${namespace}/fetchList`,
  payload: params,
});

export const setDraftOrders = (order) => ({
  type: `${namespace}/setDraftOrders`,
  payload: order,
});

export const replaceDraftOrders = (orders) => ({
  type: `${namespace}/replaceDraftOrders`,
  payload: orders,
});

export const setCurrentOrder = (order) => ({
  type: `${namespace}/setCurrentOrder`,
  payload: order,
});

export const addItemsToTable = (data) => ({
  type: `${namespace}/addItemsToTable`,
  payload: data,
});

export const removeItemFromTable = (data) => ({
  type: `${namespace}/removeItemFromTable`,
  payload: data,
});

export default {
  namespace,
  state: initialState,
  effects: {
    *removeItemFromTable({ payload }, { call, put }) {
      try {
        const response = yield call(tableService.removeItemFromTable, payload);

        if (response.data) {
          yield put({
            type: "setCurrentOrder",
            payload: response.data,
          });
          message.success("Item removed from table successfully");
        }
      } catch (error) {
        message.error(error.message);
      }
    },
    *addItemsToTable({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "addItemsToTable" });
      try {
        const response = yield call(tableService.addItemsToTable, payload);

        if (response.data) {
          yield put({
            type: "setCurrentOrder",
            payload: response.data,
          });
          message.success("Items added to table successfully");
        }
      } catch (error) {
        message.error(error.message);
      }
      yield put({ type: "stopLoading", loadingType: "addItemsToTable" });
    },
    *create({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "create" });
      try {
        const response = yield call(tableService.create, payload);
        yield put({
          type: "updateList",
          payload: response.data,
        });
        if (response.data) {
          message.success("Table created successfully");
        }
      } catch (error) {
        message.error(error.message);
      }
      yield put({ type: "stopLoading", loadingType: "create" });
    },
    *fetchCurrentOrder({ payload }, { call, put }) {
      yield put({
        type: "setCurrentOrder",
        payload: payload,
      });
    },
    *fetchOrder({ payload }, { call, put }) {
      yield put({
        type: "setDraftOrders",
        payload: payload,
      });
    },
    *fetchList({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetchList" });
      try {
        const response = yield call(tableService.fetchList, payload);
        yield put({
          type: "setList",
          payload: {
            list: response.data.list,
            total: response.data.total,
          },
        });
      } catch (error) {
        console.error("Error fetching tables:", error);
      }
      yield put({ type: "stopLoading", loadingType: "fetchList" });
    },
  },
  reducers: {
    updateList(state, { payload }) {
      return {
        ...state,
        list: [...state.list, payload],
        total: state.total + 1,
      };
    },
    setCurrentOrder(state, { payload }) {
      return {
        ...state,
        currentOrder: payload,
      };
    },
    setList(state, { payload }) {
      return {
        ...state,
        list: payload.list,
        total: payload.total,
      };
    },
    setDraftOrders(state, { payload }) {
      if (!payload?.id) {
        return state;
      }

      const existingOrderIndex = state.draftOrders.findIndex(
        (order) => order.id === payload.id,
      );

      if (existingOrderIndex === -1) {
        return {
          ...state,
          draftOrders: [...state.draftOrders, payload],
        };
      }

      const draftOrders = [...state.draftOrders];
      draftOrders[existingOrderIndex] = payload;

      return {
        ...state,
        draftOrders,
      };
    },
    replaceDraftOrders(state, { payload }) {
      const draftOrders = payload.reduce((orders, order) => {
        if (order?.id && !orders.some(({ id }) => id === order.id)) {
          orders.push(order);
        }
        return orders;
      }, []);

      return {
        ...state,
        draftOrders,
      };
    },
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
  },
};
